import Vue from 'vue'
import Vuex from 'vuex'

import cf from './modules/cf'
import contact from './modules/contact'
import form from './modules/form'
import dashboard from './modules/dashboard'
import geetest from './modules/geetest'
import login from './modules/login'
import search from './modules/search'
import share from './modules/share'
import loaded from './modules/loaded'
import transition from './modules/transition'

import activity from './modules/activity'

import * as aTypes from './action-types'
import * as mTypes from './mutation-types'
import api from '../api'
import userSupport from '../user_support'

Vue.use(Vuex)

const state = {
  dialogHtml: '',
  dialogButtonText: '',
  navTitle: '',
  pagination: {
    prevTo: null,
    nextTo: null
  },
  user: {
    avatar: null,
    email: null,
    group: {
      createTime: null,
      createUserId: null,
      name: null,
      role: null
    },
    id: null,
    manager: null,
    mobile: null,
    realname: null,
    team: {
      expireTime: null,
      id: null,
      isTrial: null,
      lingxiPlan: null,
      lingxiPlanDisplay: null,
      loginLogo: null,
      name: null,
      subdomain: null,
      titleLogo: null
    },
    username: null
  },
  notification: {
    'formfill': {
      open: false,
      loading: true
    },
    'cf_donate': {
      open: false,
      loading: true
    },
    'activity_signup': {
      open: false,
      loading: true
    }
  },
  teamInfo: {
    dataEnabled: true
  },
  wechatJsReady: false,
  userSupportSetuped: false,
  loading: {},
  qiniuConfig: {
    upload_url: '',
    common_upload_url: '',
    qiniu_token: '',
    en_team_id: '',
    en_project_id: ''
  }
}
for (const type in aTypes) {
  state.loading[type] = true
}
state.loading[aTypes.LOGIN_WITH_PHONE] = false
state.loading[aTypes.LOGIN_WITH_EMAIL] = false
state.loading[aTypes.LOGIN_SMS_VALIDATE] = false
state.loading[aTypes.LOGIN_REG_TEAM] = false
state.loading[aTypes.LOGOUT] = false
state.loading[aTypes.LOGIN_RQST_SMS_VALIDATION] = false
state.loading[aTypes.ACTIVITY_GET_SIGN_UP] = false
state.loading[aTypes.ACTIVITY_POST_SIGNIN] = false
state.loading[aTypes.ACTIVITY_POST_SIGNOUT] = false
state.loading[aTypes.ACTIVITY_POST_CANCEL_SIGNIN] = false

const actions = {
  [aTypes.GET_TEAM_INFO] ({ commit, dispatch }) {
    // api.getTeamInfo({
    //   success (res) {
    //     const dataEnabled = res.body.dataEnabled
    //     commit(mTypes.SET_TEAM_INFO, { dataEnabled: dataEnabled })
    //   },
    //   commit
    // })
  },
  [aTypes.GET_USER] ({ commit, dispatch }) {
    api.login.getUser({
      success (res) {
        const body = res.body
        const user = {
          avatar: body.avatar,
          email: body.email,
          group: {
            createTime: body.group.create_time,
            createUserId: body.group.create_user_id,
            name: body.group.name,
            role: body.group.role
          },
          id: body.id,
          manager: body.manager,
          mobile: body.mobile,
          realname: body.realname,
          team: {
            expireTime: body.team.expire_time,
            id: body.team.id,
            isTrial: body.team.is_trial,
            lingxiPlan: body.team.lingxi_plan,
            lingxiPlanDisplay: body.team.lingxi_plan_display,
            loginLogo: body.team.login_logo,
            name: body.team.name,
            subdomain: body.team.subdomain,
            titleLogo: body.team.title_logo,
            createTime: body.team.create_time
          },
          username: body.team.username
        }
        commit(mTypes.SET_USER, user)
        commit(mTypes.SET_USER_SUPPORT, true)
        userSupport(user)
        // dispatch(aTypes.ZHUGE_IDENTIFY, { id: user.id, data: user }) // 可能会晚于 zhuge track 执行，所以以模板方式取代
      },
      commit
    })
  },
  /**
   * type: formfill | cf_donate
   */
  [aTypes.GET_NOTIFICATION_STATUS] ({ commit }, { type, id }) {
    commit(mTypes.SET_NOTIFICATION_LOADING, { key: type, loading: true })
    api.getNotificationStatus({
      success (res) {
        commit(mTypes.SET_NOTIFICATION_OPEN, { key: type, open: res.body.open })
        commit(mTypes.SET_NOTIFICATION_LOADING, { key: type, loading: false })
      },
      commit
    }, { type, id })
  },
  [aTypes.TOGGLE_NOTIFICATION] ({ commit }, { type, id }) {
    commit(mTypes.SET_NOTIFICATION_LOADING, { key: type, loading: true })
    api.toggleNotificationStatus({
      success (res) {
        commit(mTypes.SET_NOTIFICATION_OPEN, { key: type, open: res.body.open })
        commit(mTypes.SET_NOTIFICATION_LOADING, { key: type, loading: false })
      },
      commit
    }, { type, id })
  },
  [aTypes.ZHUGE_IDENTIFY] ({ commit }, { id, data }) {
    window.zhuge.identify(id, data)
    // console.log(id, data)
  },
  [aTypes.ZHUGE_TRACK] ({ commit }, { event, data }) {
    window.zhuge.track(event, data)
    // console.log(event, data)
  },
  [aTypes.FETCH_WECHAT_JS_CONFIG] (context, { url }) {
    return new Promise(resolve => {
      api.fetchWechatJsConfig({
        success: resolve,
        commit: context.commit
      }, { url })
    })
  }
}

/**
 * payload: string | { html, buttonText }
 */
const mutations = {
  [mTypes.SET_DIALOG_HTML] (state, payload) {
    state.dialogButtonText = '关闭页面'
    if (payload) {
      if (typeof payload === 'string') {
        state.dialogHtml = payload
      } else {
        state.dialogHtml = payload.html
        if (payload.buttonText) {
          state.dialogButtonText = payload.buttonText
        }
      }
    } else {
      state.dialogHtml = null
    }
  },
  [mTypes.SET_NAV_TITLE] (state, title) {
    state.navTitle = title
  },
  [mTypes.SET_PAGINATION] (state, { prevTo, nextTo }) {
    state.pagination.prevTo = prevTo
    state.pagination.nextTo = nextTo
  },
  [mTypes.SET_LOADING] (state, { key, loading }) {
    state.loading[key] = loading
  },
  [mTypes.SET_USER] (state, user) {
    state.user = user
  },
  [mTypes.SET_TEAM_INFO] (state, teamInfo) {
    state.teamInfo = teamInfo
  },
  [mTypes.SET_USER_SUPPORT] (state, setuped) {
    state.userSupportSetuped = setuped
  },
  [mTypes.SET_NOTIFICATION_OPEN] (state, { key, open }) {
    state.notification[key].open = open !== 0
  },
  [mTypes.SET_NOTIFICATION_LOADING] (state, { key, loading }) {
    state.notification[key].loading = loading
  },
  [mTypes.SET_WECHAT_JS_READY] (state, { ready }) {
    state.wechatJsReady = ready
  },
  [mTypes.SET_QINIU_CONFIG] (state, config) {
    state.qiniuConfig = config
  }
}
const getters = {
  getLoading: (state) => (key) => {
    return state.loading[key]
  }
}

export default new Vuex.Store({
  modules: {
    cf,
    contact,
    form,
    dashboard,
    geetest,
    login,
    search,
    share,
    loaded,
    transition,
    activity
  },
  state,
  actions,
  mutations,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js